import { Grade } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import axios from "axios";
import { useNavigate, } from "react-router-dom";

export default function SalonCardLayout({ data }) {

    var url = 'http://localhost:1000/';
    var navi = useNavigate();

    // const data = props.data
    // const data = data;

    // console.log("dataa!!!!!!!!!!!!!", data);

    function gotoNextPage(id, name) {
        // console.log('start')
        // var ids = localStorage.getItem('ids');
        // const data = JSON.parse(ids);
        // // console.log(ids)
        // if (ids) {
        //     if (data.indexOf(id) == -1) {
        //         // navi('/Barber?id=' + id);
        //         // axios.post(url + 'viewShop', {
        //         //     Id: id,
        //         // }).then((succ) => {
        //         //     if (succ.data.result == 'success') {
        //         //         var data = JSON.parse(ids);
        //         //         console.log(data)
        //         //         console.log('done')
        //         //         navi('/Barber?id=' + id);
        //         //     } else {
        //         //         console.log('not')
        //         //     }

        //         // })
        //         data.push(id);
        //         localStorage.setItem('ids', JSON.stringify(data));
        //     }
        //     //  else {
        //     // navi('/Barber?id=' + id);
        //     // }

        // } else {
        //     var idCont = []
        //     idCont.push(id)
        //     localStorage.setItem('ids', JSON.stringify(idCont));
        //     // navi('/Barber?id=' + id);
        // }
        // axios.post(url + 'viewShop', {
        //     Id: id,
        // }).then((succ) => {
        //     if (succ.data.result == 'success') {
        //         var data = JSON.parse(ids);
        //         // console.log(data)
        //         // console.log('done')
        //         navi(`/Barber/${createSlug(name)}-${id}`);
        //     } else {
        //         // console.log('not')
        //     }

        // })
        let ids = localStorage.getItem('ids');

        let data = ids ? JSON.parse(ids) : [];

        if (!data.includes(id)) {
            data.push(id);
            localStorage.setItem('ids', JSON.stringify(data));
        }

        axios.post(url + 'viewShop', {
            Id: id,
        }).then((succ) => {

            if (succ.data.result === 'success') {

                navi(
                    `/Barber/${createSlug(name)}-${id}`
                );

            }

        });
    }
    function createSlug(name) {
        return name
            .toLowerCase()
            .trim()
            .replace(/\s+/g, "-")
            .replace(/[^\w\-]+/g, "");
    }
    if (!data) {
        return;
    } else {
        return (
            // <Grid onClick={() => gotoNextPage(row._id, row.Name)} className='slider'>
            //     <div className="rounded overflow-hidden">
            //         <img src={row.FeaturedImages ? row.FeaturedImages[0]?.url : "https://images.fresha.com/locations/location-profile-images/109064/5101385/dc22fe5b-f06c-484f-a146-c19a5b03b931-ChapsandCo-ReformattheLakes-AE-Dubai-Dubai-TheLakes-Fresha.jpg?class=venue-gallery-large&f_width=1920"} className="img-fluid slider-img rounded" />
            //     </div>
            //     <div className="d-flex align-items-center mt-2 justify-content-between">
            //         <Typography variant="h6" fontSize={20} fontWeight={700} display={'inline'}>{row.Name}</Typography>
            //         <div className="d-flex align-items-center">
            //             <Grade fontSize="medium" sx={{ color: '#FFC00A' }} />
            //             <span className="fw-bold ms-1">{!row.AvgRating ? ('?'
            //             ) : row.AvgRating.toFixed(1)}</span>
            //         </div>
            //     </div>
            //     <span className="address-font col-6">
            //         {Math.floor(Number(row.distance) / 1000)} km
            //     </span>
            //     <span className="d-block address-font">Hair Salon</span>
            // </Grid>

            //  {/* <Slider autoplay autoplaySpeed={2500} className="slider-cont mx-auto" useCSS infinite={true} dots={false} swipe speed={500} slidesToShow={4} slidesToScroll={4}> */}
            <Grid onClick={() => gotoNextPage(data._id, data.Name)} className='slider'>
                <div className="rounded overflow-hidden">
                    <img src={data.FeaturedImages ? data.FeaturedImages[0]?.url : "https://images.fresha.com/locations/location-profile-images/109064/5101385/dc22fe5b-f06c-484f-a146-c19a5b03b931-ChapsandCo-ReformattheLakes-AE-Dubai-Dubai-TheLakes-Fresha.jpg?class=venue-gallery-large&f_width=1920"} className="img-fluid slider-img rounded" />
                </div>
                <div className="d-flex align-items-center mt-2 justify-content-between">
                    <Typography variant="h6" fontSize={20} fontWeight={700} display={'inline'}>{data.Name}</Typography>
                    <div className="d-flex align-items-center">
                        <Grade fontSize="medium" sx={{ color: '#FFC00A' }} />
                        <span className="fw-bold ms-1">{!data.AvgRating ? ('?'
                        ) : data.AvgRating.toFixed(1)}</span>
                    </div>
                </div>
                <span className="address-font col-6">
                    {Math.floor(Number(data.distance) / 1000)} km
                </span>
                <span className="d-block address-font">Hair Salon</span>
            </Grid>
        )
    }
}